import React, { useContext, useEffect, useState } from 'react'
import logowrap from '../../assets/images/Adidas-logo.png';
import { Button, Form } from 'react-bootstrap';
import { FaRegEdit } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { GrLocation } from "react-icons/gr";
import { BsEye, BsEyeSlash, BsTelephone } from "react-icons/bs";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { RiLogoutCircleRLine } from "react-icons/ri";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import logogetto from '../../assets/svg/logo-dashboard-v1.png'
import { getStoresListing } from '../../api/context/manufacturer';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { changePassword, removeFcmToken } from '../../api/context/auth';

const MyProfile = () => {

    const navigate = useNavigate()

    const user = JSON.parse(localStorage.getItem('user'));
    const fcmToken = localStorage.getItem('fcmToken');

    const [modal, setModal] = useState(false);
    const [store, setStore] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false
    });

    const togglePasswordVisibility = (fieldName) => {
        setShowPassword(prev => ({ ...prev, [fieldName]: !prev[fieldName] }));
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const editStore = () => {
        navigate('/edit-vendors/' + store.id)
    }

    const logoutUser = () => {
        setModal(!modal);
    }

    const logoutStore = () => {
        const fcmToken = localStorage.getItem('fcmToken');
        if (fcmToken) {
            removeFcmToken({ fcmToken })(() => {
                // Optionally handle response
            });
        }
        localStorage.clear();
        toast.success("Log out successfully");
        navigate("/login");
    }

    const formatTime = (timeString) => {
        const time = new Date(`1970-01-01T${timeString}`);

        const hours = time.getHours().toString().padStart(2, '0');
        const minutes = time.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    };

    const formik = useFormik({
        initialValues: {
            oldPassword: "",
            newPassword: "",
        },
        validationSchema: Yup.object().shape({
            oldPassword: Yup.string()
                .required('Required'),
            newPassword: Yup.string()
                .required('Required'),
        }),
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword
            };
            changePassword(payload)((response) => {
                if (response && response.statusCode == 200) {
                    toast.success(response?.message)
                    formik.resetForm();
                    setLoading(false);

                }
                else {
                    toast.error(response?.response?.data?.message);
                    setLoading(false);
                }
            });
        },
    });

    const getStoresDetails = () => {
        getStoresListing()((response) => {

            if (response?.statusCode == 200) {
                setStore(response?.data?.[0]);
            } else {

            }
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };

    useEffect(() => {
        getStoresDetails()
    }, []);


    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">My Profile</h4>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-12'>
                        {user?.userType === 'ADMIN' ?
                            <div className='account_user'>
                                <div className='img_wrapper'>
                                    <img src={logogetto} className='logo_img img-fluid' alt='Logo' />
                                </div>
                                <div className='contents'>
                                    <h5>{user?.firstName}</h5>
                                    <p>{user?.email}</p>
                                </div>
                            </div>
                            :
                            <div className='account_user'>
                                <div className='img_wrapper'>
                                    <img src={store?.image ? store?.image : logogetto} className='logo_img img-fluid' alt={store?.storeName} />
                                </div>
                                <div className='contents'>
                                    <h5>{store?.storeName ? store?.storeName : user?.firstName}</h5>
                                    <p>{store?.ownerName ? store?.ownerName : user?.email}</p>
                                </div>
                            </div>
                        }

                        {user?.userType === 'ADMIN' ? (
                            <></>
                        ) : (
                            store?.id && (
                                <>
                                    <div className='store_user_details'>
                                        <div className='store_details'>
                                            <h5>Store Details</h5>
                                            <Button className='update_btn' onClick={() => editStore()}><FaRegEdit className='icon' /> Edit Store</Button>
                                        </div>
                                        <div className='br_bottom'></div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <GrLocation className='icon' />
                                                <h6>Location</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <p>{store?.address} {store?.city}, {store?.state}</p>
                                                <span>{store?.landmark}</span>
                                            </div>
                                        </div>
                                        <div className='br_bottom'></div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <BsTelephone className='icon' />
                                                <h6>Contact Number</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <p>{store?.phoneNumber}</p>
                                            </div>
                                        </div>
                                        <div className='br_bottom'></div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <MdOutlineMailOutline className='icon' />
                                                <h6>E-Mail</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <p>{store?.email}</p>
                                            </div>
                                        </div>
                                        <div className='br_bottom'></div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <IoMdTime className='icon' />
                                                <h6>Store Timings</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                {store?.StoreTimings?.map((data, index) => (
                                                    <p key={index}>
                                                        {data.isActive ?
                                                            `${data.day} ${formatTime(data.openingTime)} - ${formatTime(data.closingTime)}` :
                                                            `${data.day} Closed`
                                                        }
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='store_bank_details'>
                                        <div className='store_details'>
                                            <h5>Bank Details</h5>
                                        </div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <h6>Card Holder</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <span>{store?.VendorBankDetails?.[0]?.accountHolderName ? store?.VendorBankDetails?.[0]?.accountHolderName : ''}</span>
                                            </div>
                                        </div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <h6>Account Number </h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <span>{store?.VendorBankDetails?.[0]?.accountNumber ? store?.VendorBankDetails?.[0]?.accountNumber : ''}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='store_bank_details'>
                                        <div className='store_details'>
                                            <h5>Business Details</h5>
                                        </div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <h6>GST</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <span>{store?.VendorBankDetails?.[0]?.gst ? store?.VendorBankDetails?.[0]?.gst : ''}</span>
                                            </div>
                                        </div>
                                        <div className='store_details'>
                                            <div className='inner_left_wrap'>
                                                <h6>PAN</h6>
                                            </div>
                                            <div className='inner_right_wrap'>
                                                <span>{store?.VendorBankDetails?.[0]?.pan ? store?.VendorBankDetails?.[0]?.pan : ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        )}

                        <div className='store_bank_details'>
                            <div className='store_details'>
                                <h5>Change Password</h5>
                            </div>
                            <Form className='change_pass_form_wrapper' onSubmit={formik.handleSubmit}>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Old Password</Form.Label>
                                            <div className='eye_icon_wrapper'>
                                                <Form.Control
                                                    type={showPassword.oldPassword ? 'text' : 'password'}
                                                    placeholder=""
                                                    name='oldPassword'
                                                    value={formik.values?.oldPassword}
                                                    onChange={handleInputChange}
                                                    isValid={formik.touched.oldPassword && !formik.errors.oldPassword}
                                                    isInvalid={formik.touched.oldPassword && !!formik.errors.oldPassword}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.oldPassword}</Form.Control.Feedback>
                                                {showPassword.oldPassword ? (
                                                    <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("oldPassword")} />
                                                ) : (
                                                    <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("oldPassword")} />
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className='col-lg-6'>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>New Password</Form.Label>
                                            <div className='eye_icon_wrapper'>
                                                <Form.Control
                                                    type={showPassword.newPassword ? 'text' : 'password'}
                                                    placeholder=""
                                                    name='newPassword'
                                                    value={formik.values?.newPassword}
                                                    onChange={handleInputChange}
                                                    isValid={formik.touched.newPassword && !formik.errors.newPassword}
                                                    isInvalid={formik.touched.newPassword && !!formik.errors.newPassword}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.newPassword}</Form.Control.Feedback>
                                                {showPassword.newPassword ? (
                                                    <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("newPassword")} />
                                                ) : (
                                                    <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("newPassword")} />
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                <Button className='login_btn' type="submit">
                                    {loading ? "Loading" : "Update"}
                                </Button>
                            </Form>
                        </div>

                        <div className='btn_wrapper_logout'>
                            <Button className='update_btn' onClick={() => logoutUser()}><RiLogoutCircleRLine className='icon' /> Log Out</Button>
                        </div>
                        <CustomisedModal
                            isOpen={modal}
                            customClass={"policy_modal"}
                            toggle={toggleModal}
                        >
                            <h5>
                                Are you sure you want to log out?
                            </h5>
                            <div className="policy_Agree">
                                <Button
                                    onClick={() => {
                                        setModal(!modal);
                                    }}
                                    size="lg"
                                    className='btn_cancel'
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="lg"
                                    className='btn'
                                    onClick={() => logoutStore()}
                                >
                                    Log Out
                                </Button>
                            </div>
                        </CustomisedModal>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyProfile